import React, { VoidFunctionComponent } from 'react';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import {
  ExportWorkTimeBaseDialog,
  ExportWorkTimeBaseDialogProps
} from '../ExportWorkTimeBaseDialog/ExportWorkTimeBaseDialog';

export type ExportOwnWorkTimeDialogProps = Omit<
  ExportWorkTimeBaseDialogProps,
  'getUserId'
>;

export const ExportOwnWorkTimeDialog: VoidFunctionComponent<ExportOwnWorkTimeDialogProps> =
  React.memo((props) => {
    const { ...remainingProps } = prepareProps({ props, ignoreChildren: true });

    const { getRequiredCurrentUser } = useCurrentUser();

    const getUserId = useEventCallback(() => {
      return getRequiredCurrentUser().id;
    });

    return (
      <ExportWorkTimeBaseDialog
        {...remainingProps}
        getUserId={getUserId}
      ></ExportWorkTimeBaseDialog>
    );
  });
